/**
 * This function is required for the custom popup form.
 */
export default () => {
    const $showCustomFormPopup = $('.show-custom-form-popup'),
        $customFormPopup = $('.custom-form-popup');

    // Early exit, if class/id are not present on page exit function.
    if (
        $showCustomFormPopup.length === 0 ||
        $customFormPopup.length === 0
    ) {
        return;
    }

    $showCustomFormPopup.each(function() {
        const $buttonElement = $(this);
        const button = $buttonElement.data('button');

        $buttonElement.on('click', function(e) {
            // Open the correct popup
            $(`.custom-form-popup[data-form="${button}"]`).each(function() {
                const $formElement = $(this);

                if ($formElement.data('form', button)) {
                    if ($formElement.is(':visible')) {
                        $formElement.hide();
                    } else {
                        // Stop default click functionality i.e. scrolling to top of page
                        e.preventDefault();
                        $formElement.show();
                    }
                } else {
                    $formElement.hide();
                }
            });
        });
    });

    // Close the popup
    const $closeFormButton = $('.custom-form-popup .close-btn');

    $closeFormButton.on('click', function(e) {
        $customFormPopup.hide();
    });
}